import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Search, Heart } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-warm flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-8">
          <div className="w-24 h-24 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Search className="w-12 h-12 text-rose-600" />
          </div>
          
          <h1 className="font-playfair text-6xl font-bold text-gray-900 mb-4">
            404
          </h1>
          
          <h2 className="font-playfair text-2xl font-semibold text-gray-900 mb-4">
            Page Not Found
          </h2>
          
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or may have been moved. 
            Let's get you back to finding meaningful connections!
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/')}
            className="w-full btn-primary py-3 flex items-center justify-center space-x-2"
            data-testid="home-btn"
          >
            <Home className="w-5 h-5" />
            <span>Back to Home</span>
          </button>
          
          <button
            onClick={() => navigate('/discover')}
            className="w-full btn-secondary py-3 flex items-center justify-center space-x-2"
            data-testid="discover-btn"
          >
            <Heart className="w-5 h-5" />
            <span>Start Discovering</span>
          </button>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          Need help? <a href="/contact" className="text-rose-600 hover:underline">Contact Support</a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;